import React from "react"
import { graphql } from "gatsby"

export default ( props ) => {
  return
}

export const query = graphql`
fragment FacewallData on ReviewsJson {
    title
    reviewerName
    reviewType
    reviewLanguage
    thumbnailPublicId
    monthYear {
      month
      year
    }
  }
`